module.exports = __webpack_public_path__ + "media/bootstrap-icons/info-square-6163c2b4.svg";